import { twMerge } from 'tailwind-merge'
import { DetailsTableDataGroup } from '../models'

export interface DataGroupTableProps {
  isFirstGroup?: boolean
}

export function DataGroupTable({
  values,
  isFirstGroup,
  label,
  labelClassName,
}: DataGroupTableProps & DetailsTableDataGroup) {
  return (
    <div data-testid="dataGroupTable" className={`-ml-2 ${!isFirstGroup ? 'pt-6' : ''}`}>
      {label ? <div className={twMerge('pb-[10px]', labelClassName)}>{label}</div> : ''}
      {values?.map((item, i) => (
        <div key={item.label} className={twMerge('flex rounded py-1 px-2', i % 2 === 1 ? 'bg-shades-25' : '')}>
          <div className="w-1/2">{item.label}</div>
          <div className="w-1/2 text-right font-bold">{item.value}</div>
        </div>
      ))}
    </div>
  )
}
